import { render, staticRenderFns } from "./[id].vue?vue&type=template&id=cba16fea"
import script from "./[id].vue?vue&type=script&lang=js"
export * from "./[id].vue?vue&type=script&lang=js"
import style0 from "./[id].vue?vue&type=style&index=0&id=cba16fea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports